import React from 'react';

const LazyLogin = React.lazy(() =>
  import(/* webpackChunkName: "Login" */ './otp')
);

const Otp = (props: Record<string, any>) => (
  <React.Suspense fallback={<h1>Loading...</h1>}>
    <LazyLogin {...props} />
  </React.Suspense>
);

export default Otp